import { render, staticRenderFns } from "./InterpreterShowedUpSection.vue?vue&type=template&id=c28ec008&scoped=true&"
import script from "./InterpreterShowedUpSection.vue?vue&type=script&lang=js&"
export * from "./InterpreterShowedUpSection.vue?vue&type=script&lang=js&"
import style0 from "./InterpreterShowedUpSection.vue?vue&type=style&index=0&id=c28ec008&prod&lang=css&"
import style1 from "./InterpreterShowedUpSection.vue?vue&type=style&index=1&id=c28ec008&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28ec008",
  null
  
)

export default component.exports